import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const TrainingDashboardTourSteps = [
	{
		selector: '[data-tour="training-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Welcome">
					Welcome to the Training Dashboard. This page gives you a high-level
					overview of training compliance, overdue sessions, KPI performance,
					upcoming schedules, and participants who have missed sessions.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Tabs">
					Use these tabs to switch between Dashboard, Courses, Drills, Archive,
					and Planner. Dashboard shows the overview here; Courses and Drills
					show detailed session management; Archive lists completed sessions;
					Planner helps schedule training.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-snapshot"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Snapshot">
					KPI snapshot — five quick metrics: average response time (last 30
					days), staff compliance based on missed trainings, overdue course
					sessions, overdue drill sessions, and days since last incident. Each
					card is clickable and navigates to the relevant section.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-kpi-controls"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.KPIControls">
					Performance overview controls — select 2, 6, or 12 months to change
					the date range for the KPI statistics below. Use Go to KPI to open the
					full archive view with detailed historical data.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-kpi-grid"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.KPIGrid">
					KPI data grid — shows averages and counts for response times,
					compliance, completed trainings, and drills over the selected period.
					Use this to spot trends and identify areas that need attention.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-upcoming-archive"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.UpcomingArchive">
					Upcoming, overdue, and archive cards — six cards showing Training and
					Drill sessions: upcoming sessions (future dates), overdue sessions
					(past due), and archived sessions (completed). Click a session to view
					details or use the links to navigate to Courses, Drills, or Archive.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-missed"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Missed">
					Participants with missed sessions — lists staff who have not completed
					required trainings or drills. Use this to follow up on non-compliant
					participants and ensure everyone completes their scheduled sessions.
				</Translate>
			</Box>
		),
	},
];
